export enum HermesErrorCodes {
  MISSING_REFRESH_TOKEN = 'HM09',
  INVALID_TOKEN = 'HM07',
}
